<template>
  <el-dialog
    class="el-dialog-cus-NewCss"
    v-bind="attributes"
    :visible.sync="visible"
    append-to-body
    :width="attributes.width"
    :close-on-click-modal="attributes.close_on_click_modal"
  >
    <slot v-if="visibleSlot"></slot>
    <span
      v-if="diaText"
      class="diaText"
      :style="attributes.txtcenter ? 'text-align: center' : ''"
      >{{ diaText }}</span
    >
    <div slot="footer" style="text-align: center" v-if="attributes.showBtn">
      <el-button
        @click="
          queRen();
          cancel();
        "
        v-if="btnTxt[0]"
        class="bgBlueBtn"
        >{{ btnTxt[0] }}</el-button
      >
      <el-button
        v-if="btnTxt[1]"
        @click="
          quXiao();
          cancel();
        "
        class="fontBlueBtn"
        >{{ btnTxt[1] }}</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    config: Object,
  },
  data() {
    const {
      top = "20vh",
      width = "480px",
      title = this.$fanyi("提示"),
      txtcenter = false,
      btnTxt = [this.$fanyi("确定"), this.$fanyi("取消")],
    } = this.config || {};
    return {
      visible: false,
      attributes: {
        top,
        width,
        title,
        showBtn: true,
        close_on_click_modal: true,
        ...this.config,
      },
      btnTxt,
      visibleSlot: false,
      queRen: () => {},
      quXiao: () => {},
      diaText: null,
    };
  },
  methods: {
    open(text, queRen, quXiao, data) {
      if (data) {
        for (let i in data) {
          this.attributes[i] = data[i];
        }
      }
      this.diaText = text;
      queRen ? (this.queRen = queRen) : "";
      quXiao ? (this.quXiao = quXiao) : "";
      this.visible = true;
      this.visibleSlot = true;
      return this.$nextTick();
    },
    cancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/mixin.scss";
.el-dialog-cus-NewCss {
  /deep/.el-dialog {
    border-radius: 16px;
    border: 2px solid var(--Gray-300, #d0d5dd);
  }
  /deep/.el-dialog__title {
  }
  /deep/.el-dialog__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px;
    font-size: 18px;
    font-weight: 700;
    line-height: 28px; /* 155.556% */
    height: 85px;
    .el-dialog__headerbtn {
      position: none;
      font-size: 20px;
    }
  }
  /deep/.el-dialog__headerbtn {
  }
  /deep/.el-dialog__body {
    padding: 0 0px 0px;
  }
  /deep/.el-dialog__footer {
    padding: 0 24px 24px;
    .el-button {
      min-width: 120px;
      height: 40px;
      padding: 0px 14px;
      font-size: 14px;
      font-weight: 700;
      margin: 0 8px;
    }
  }
  .diaText {
    font-size: 16px;
    color: #000000;
    line-height: 24px;

    display: inline-block;
    // width: 100%;
    margin: 0 24px 48px;
  }
}
</style>
